/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgForgotPassword.css";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import { simpleFetch } from "../../restWrapper";
import errorMsg from "../../assets/json/errMsg.json";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { renderOrgLanguageSelector } from "../../assets/component/renderOrgLanguageSelector.js";

class OrgForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: this.props.language,
      username: "",
      errorMsg: "",
      buttonClick: false,
      loading: false,
    };
    this.handleUsername = this.handleUsername.bind(this);
    this.submitBtn = this.submitBtn.bind(this);
  }
  componentDidMount() {
    try {
      if (
        this.props.location.state.username !== null ||
        this.props.location.state.username !== undefined
      ) {
        this.setState({
          username: this.props.location.state.username,
        });
      }
    } catch (e) {
      this.setState({
        username: "",
      });
    }
  }

  handleUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }

  submitBtn(e) {
    this.setState({
      buttonClick: true,
      loading: true,
    });

    if (!this.state.username) return;

    simpleFetch("/organizations/forgot/", "POST", {
      username: this.state.username,
      language: this.state.language,
    }).then((res) => {
      this.setState({
        loading: false,
      });
      switch (res.status) {
        case 404:
          this.props.history.push({
            pathname: "/OrgRegisterInfo",
            state: {
              username: this.state.username,
            },
          });
          break;
        case 422:
          this.setState({
            errorMsg: errorMsg[this.state.language].loginErr.loginEmailErr,
            buttonClick: false,
          });
          break;
        case 204:
          this.props.history.push({
            pathname: "/OrgForgotPasswordConfirm",
            confirm: true,
          });
          break;
        default:
          this.setState({
            errorMsg: errorMsg[this.state.language].fail,
            buttonClick: false,
          });
          break;
      }
    });
  }

  render() {
    if (
      this.props.location.state === null ||
      this.props.location.state === undefined ||
      this.state.loading
    ) {
      return (
        <div className="OrgForgotPassword-view">
          <div className="OrgForgotPassword-loadingPrompt">
            <this.props.RenderFullPageLoading />
          </div>
        </div>
      );
    }

    const languageObj = this.props.languageObj;

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.submitBtn();
      }
    };

    return (
      <div className="OrgForgotPassword-view">
        <div className="OrgForgotPassword-prompt">
          <div className="OrgForgotPassword-languageBar">
            <div className="OrgForgotPassword-languageSelector">
              {renderOrgLanguageSelector()}
            </div>
          </div>

          <Link to={"/OrgLogin"}>
            <div className="OrgForgotPassword-backContainer">
              <div className="OrgForgotPassword-backIcn" />
            </div>
          </Link>

          <div className="OrgForgotPassword-loginContainer">
            <div className="OrgForgotPassword-CheckPlusLogo" />

            <div className="OrgForgotPassword-loginText">
              {languageObj.loginText}
            </div>

            <div className="OrgForgotPassword-text">
              {languageObj.text[0]}

              {languageObj.text[1]}
            </div>

            <div className="OrgForgotPassword-inputFieldContainer">
              <div className="OrgForgotPassword-inputContainerLeft">
                <input
                  type="text"
                  className="OrgForgotPassword-inputField"
                  value={this.state.username}
                  onChange={this.handleUsername}
                  placeholder={languageObj.inputField}
                  onKeyDown={handleKeyDown}
                />
              </div>
              <div className="OrgForgotPassword-inputContainerRight">
                <div
                  className="OrgForgotPassword-nextBtn"
                  style={{
                    disabled: this.state.buttonClick,
                  }}
                  onClick={this.submitBtn}
                >
                  <div className="OrgForgotPassword-nextIcn" />
                </div>
              </div>
            </div>
            {renderErrorMsg(this.state.errorMsg)}
          </div>
        </div>
      </div>
    );
  }
}

OrgForgotPassword.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default OrgForgotPassword;
